const TabsSkeleton = () => (
  <div className="relative animate-pulse">
    <div className="gap-2 flex flex-row overflow-x-auto noScrollbar">
      <div className="w-28 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-t-3xl border-b-[3px] border-border-tertiary" />
      <div className="w-28 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-t-3xl border-b-[3px] border-border-tertiary" />
      <div className="w-28 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-t-3xl border-b-[3px] border-border-tertiary" />
      <div className="w-28 h-10 bg-neutral-200 dark:bg-neutral-700 rounded-t-3xl border-b-[3px] border-border-tertiary" />
    </div>
  </div>
);

export default TabsSkeleton;
